module.exports = __webpack_public_path__ + "static/img/SetBanner.2392c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SetBanner.png
// module id = j/r6
// module chunks = 1